<template>
    <section class="content">
        <div class="container-fluid">
            <div class="block-header">
                <h2>Edit Anggota</h2>
            </div>
            <div class="row clearfix">
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <div class="card">
                        <div class="header">
                            <h2>
                                Edit Anggota
                            </h2>
                        </div>
                        <div class="body">
                            <form class="form-horizontal" v-on:submit.prevent="save">
                                <div class="row clearfix">
                                    <div class="col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label">
                                        <label for="nip">NIP</label>
                                    </div>
                                    <div class="col-lg-10 col-md-10 col-sm-8 col-xs-7">
                                        <div class="form-group">
                                            <form-line id="nip" type="text" v-model="data.nip" disabled></form-line>
                                        </div>
                                    </div>
                                </div>

                                <div class="row clearfix">
                                    <div class="col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label">
                                        <label for="namaPeserta">Nama Peserta</label>
                                    </div>
                                    <div class="col-lg-10 col-md-10 col-sm-8 col-xs-7">
                                        <div class="form-group">
                                            <form-line id="namaPeserta" type="text" v-model="data.namaPeserta"></form-line>
                                        </div>
                                    </div>
                                </div>

                                <div class="row clearfix">
                                    <div class="col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label">
                                        <label for="sex">Sex</label>
                                    </div>
                                    <div class="col-lg-10 col-md-10 col-sm-8 col-xs-7">
                                        <div class="form-group">
                                            <select class="form-control" name="sex" id="sex" v-model="data.sex">
                                                <option value="P">Pria</option>
                                                <option value="W">Wanita</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>

                                <div class="row clearfix">
                                    <div class="col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label">
                                        <label for="tglBekerja">Tanggal Bekerja</label>
                                    </div>
                                    <div class="col-lg-10 col-md-10 col-sm-8 col-xs-7">
                                        <div class="form-group">
                                            <div class="form-line">
                                                <flat-pickr class="form-control" id="tglBekerja" v-model="data.tglBekerja" :config="date"></flat-pickr>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="row clearfix">
                                    <div class="col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label">
                                        <label for="tglHenti">Tanggal Berhenti</label>
                                    </div>
                                    <div class="col-lg-10 col-md-10 col-sm-8 col-xs-7">
                                        <div class="form-group">
                                            <div class="form-line">
                                                <flat-pickr class="form-control" id="tglHenti" v-model="data.tglHenti" :config="date"></flat-pickr>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="row clearfix">
                                    <div class="col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label">
                                        <label for="golongan">Golongan</label>
                                    </div>
                                    <div class="col-lg-10 col-md-10 col-sm-8 col-xs-7">
                                        <div class="form-group">
                                            <form-line id="golongan" type="text" v-model="data.gol"></form-line>
                                        </div>
                                    </div>
                                </div>

                                <div class="row clearfix">
                                    <div class="col-lg-offset-2 col-md-offset-2 col-sm-offset-4 col-xs-offset-5">
                                        <button v-bind:disabled="isLoading" @click="update" type="button" class="btn btn-warning waves-effect waves-button" v-waves.button>
                                            <span v-if="!isLoading"><i class="material-icons">save</i> Edit</span>
                                            <span v-else><i class="fa fa-spinner fa-spin"></i> Loading</span>
                                        </button>
                                        <button @click="$router.go(-1)" type="button" class="btn btn-danger" v-waves.button><i class="material-icons">cancel</i> Batal</button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
  import FormLine from '@/components/FormLine.vue'
  import api from '@/helper/api'

  export default {
    components: {FormLine},
    name: 'EditAnggota',
    data: function () {
      return {
        date: {
          dateFormat: 'Y-m-d',
          allowInput: true
        },
        data: {},
        nip: '',
        isLoading: false
      }
    },
    methods: {
      update () {
        api.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token')
        api.post('/anggota/' + this.nip, this.data).then((result) => {
          if (result.data.code === 200) {
            this.$router.replace('/main/anggota')
            this.$toastr.s('Ubah data berhasil')
          }
        }).catch((ex) => {
          this.$toastr.e('Terjadi kesalahan pada server, mohon ulangi')
        })
      },
      getDetail () {
        api.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token')
        api.get('/anggota/' + this.nip).then((result) => {
          this.data = result.data
        }).catch((ex) => {
          this.$toastr.e('Terjadi kesalahan pada server, mohon ulangi')
        })
      },
      handleFile (file) {
        this.file = file.target.files[0]
      }
    },
    mounted () {
      this.nip = this.$route.params.id
      this.getDetail()
    }
  }
</script>


// WEBPACK FOOTER //
// src/view/Anggota/EditAnggota.vue